import React from "react";
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, Typography, Button } from "@mui/material";
import Calendario from '@mui/icons-material/Event';
import Reloj from '@mui/icons-material/AccessTimeRounded';
import Ubicacion from '@mui/icons-material/LocationOnRounded';
import { Chip } from "@mui/material";

const verificarSiTurnoPaso = (fechaString, horaString) => {
  const [dia, mes, anio] = fechaString.split("/");
  const [horas, minutos] = horaString.split(":");
  
  const fechaTurno = new Date(anio, mes - 1, dia, horas, minutos);
  const ahora = new Date();
  
  return fechaTurno < ahora;
};

const obtenerColorEstado = (estado) => {
  switch (estado) {
    case "DISPONIBLE":
    case "CONFIRMADO":
      return "success";

    case "RESERVADO":
    case "PENDIENTE":
      return "warning";

    case "CANCELADO":
      return "error";

    case "REALIZADO":
      return "default";

    default:
      return "default";
  }
};

const MisTurnoCard = ({ turno, onCancelar, onModificar }) => {
  const theme = useTheme();
  const turnoPasado = verificarSiTurnoPaso(turno.fecha, turno.hora);

  return (
    <Card 
      variant="outlined"
      className="turno-card-mui"
      style={{ '--rojo-theme': theme.palette.primary.main }}
    >
      <CardContent className="turno-card-content">
                  <div
            className="turno-card-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start"
            }}
          >
            <div>
              <Typography variant="h6" fontWeight="bold">
                {turno.medico}
              </Typography>
          
              {turno.especialidad && (
                <Typography variant="body2" color="primary" sx={{ mt: 0.5 }}>
                  {turno.especialidad}
                </Typography>
              )}
            </div>
            
            <Chip
              label={turno.estado}
              color={obtenerColorEstado(turno.estado)}
              size="small"
            />
          </div>

        <div className="turno-card-body">
          <div className="info-line">
            <Calendario className="info-icon" />
            <Typography variant="body2" color="text.secondary">
              {turno.fecha}
            </Typography>
          </div>

          <div className="info-line">
            <Reloj className="info-icon" />
            <Typography variant="body2" color="text.secondary">
              {turno.hora}
            </Typography>
          </div>

          <div className="info-line">
            <Ubicacion className="info-icon" />
            <Typography variant="body2" color="text.secondary">
              {turno.sede || turno.ubicacion || "Ubicación no especificada"}
            </Typography>
          </div>
        </div>

        {turno.fechaPropuesta && (
          <div 
            className="info-line propuesta-modificacion" 
            style={{ 
              marginTop: '12px', 
              padding: '10px', 
              backgroundColor: '#fff0f2', 
              borderRadius: '8px',
              border: `1px solid ${theme.palette.primary.main}`
            }}
          >
            <Typography variant="body2" color="primary" fontWeight="bold">
              Propuesta del medico: {turno.fechaPropuesta} - {turno.horaPropuesta}
            </Typography>
          </div>
        )}

        {turno.estado === "CANCELADO" && (
        <div
          style={{
            marginTop: "12px",
            padding: "10px",
            backgroundColor: "#ffebee",
            borderRadius: "8px",
            border: "1px solid #ef5350"
          }}
        >
          <Typography 
            variant="body2" 
            color="error"
            fontWeight="bold"
          >
            Motivo de cancelación:
          </Typography>
        
          <Typography variant="body2">
            {turno.motivoCancelacion || "Sin motivo especificado"}
          </Typography>
        </div>
      )}
        
      {!turnoPasado && turno.estado !== "CANCELADO" && (onCancelar || onModificar) && (
          <div 
            className="turno-card-acciones-wrapper" 
            style={{ 
              marginTop: '16px', 
              display: 'flex', 
              gap: '10px', 
              flexDirection: 'row' 
            }}
          >
            {onCancelar && (
              <Button 
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => onCancelar(turno.id, turno.medico)}
                disableElevation
                style={{ fontWeight: '600', borderRadius: '8px' }}
              >
                Cancelar
              </Button>
            )}

            {onModificar && (
              <Button 
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => onModificar(turno.id)}
                disableElevation
                style={{ fontWeight: '600', borderRadius: '8px' }}
              >
                Modificar
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MisTurnoCard;